import { connect } from '../../../../common/react-redux';
import ResetQuizPresenter from './presenter';
import { withConfirm } from '../../../../common/actions/modal';
import { screenreaderNotification } from '../../../../common/actions/alerts';
import { featureOn } from '../../../../common/util/featureCheck';
import { reopenQuizSession } from '../../../api/quizSessions';
import { getQuizSessionsByIds } from '../../../../common/selectors/quizSessions';
export function mapStateToProps(state) {
  var quizSessionIds = state.getIn(['moderation', 'selectedSessions']);
  var quizSessions = getQuizSessionsByIds(state, quizSessionIds).filter(function (qs) {
    return qs.isLoaded() && !qs.pending();
  }).sort(function (qs1, qs2) {
    return qs2.id - qs1.id;
  });
  var quizSessionId,
    quizSession,
    reopenOverride = false;
  if (quizSessions.size > 0) {
    quizSession = quizSessions.get(0);
    var _ref = [quizSession.allowBacktracking, quizSession.isOneQuestionAtATime()],
      allowBacktracking = _ref[0],
      isOneQuestionAtATime = _ref[1];
    quizSessionId = quizSession.id;
    reopenOverride = !allowBacktracking && isOneQuestionAtATime;
  }
  return {
    sessionId: quizSessionId || null,
    isComplete: quizSession ? !(quizSession.inProgress() || quizSession.reopeningGraded()) : false,
    reopenOn: featureOn('reopen_session'),
    reopenOverride: reopenOverride
  };
}
export default connect(mapStateToProps, {
  reopenQuizSession: reopenQuizSession,
  screenreaderNotification: screenreaderNotification,
  withConfirm: withConfirm
})(ResetQuizPresenter);